import { render } from "./VersionHistory.vue?vue&type=template&id=3aae391c"
const script = {}

import "./VersionHistory.vue?vue&type=style&index=0&id=3aae391c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__